export default function tallowCalculatorComponent() {
    return {
        step: 1, // 1 = input, 2 = results
        locations: '',
        oilPerLocation: '',
        estimatedSavings: 0,

        calculate() {
            const locs = parseFloat(this.locations) || 0;
            const oilPerWeek = parseFloat(this.oilPerLocation) || 0;
            const oilPerMonth = oilPerWeek * 4;

            // Seed oil: full volume at $1.0393/lb
            const seedOilCostPerLb = 1.0393;
            const costPerMonthA = locs * oilPerMonth * seedOilCostPerLb;
            const costPerYearA = costPerMonthA * 12;

            // Tallow: 2/3 the volume (better fry life) at $1.1155/lb
            const tallowPerMonth = oilPerMonth * (2 / 3);
            const tallowCostPerLb = 1.1155;
            const costPerMonthB = locs * tallowPerMonth * tallowCostPerLb;
            const costPerYearB = costPerMonthB * 12;

            this.estimatedSavings = Math.round(costPerYearA - costPerYearB);
            this.step = 2;
        },

        get formattedSavings() {
            return '$' + this.estimatedSavings.toLocaleString('en-US');
        },

        get canCalculate() {
            return parseFloat(this.locations) > 0 && parseFloat(this.oilPerLocation) > 0;
        },

        startOver() {
            this.step = 1;
            this.locations = '';
            this.oilPerLocation = '';
            this.estimatedSavings = 0;
        },

        openDistributor() {
            // Access parent (body) scope via Alpine's scope chain
            this.isTallowCalculatorOpen = false;
            this.$nextTick(() => {
                this.isDistributorPopupOpen = true;
                this.$dispatch('block-overflow');
            });
        },

        openContact() {
            this.isTallowCalculatorOpen = false;
            this.$nextTick(() => {
                this.isContactsPopupOpen = true;
                this.$dispatch('block-overflow');
            });
        },

        closeSelf() {
            this.isTallowCalculatorOpen = false;
            this.$dispatch('unblock-overflow');
        },
    };
}
